import React, { useEffect, useState } from "react"

import { Form, Button } from "react-bootstrap"
import { useParams } from "react-router-dom"
import { localize } from "services/base"
import { get_countries } from "services/region"
import { useSignalEffect } from "@preact/signals-react"
import { user_info } from "signals/user"
import { changeFormData, form_data, sort_field } from "signals/form"
import { create_address, edit_address, get_form_by_id } from "services/form"
import ListField from "./Field"
import { param } from "signals/base"

const RegistrationForm = () => {
	const { form_id } = useParams()
	const t = (key) => localize(key)
	const list_field = sort_field.value
	const [isValidated, setIsValidated] = useState(false)

	useSignalEffect(() => {
		if (user_info.value) {
			get_countries()
			if (form_id) {
				get_form_by_id(form_id)
			}
		}
	}, [form_id])

	const checkRegex = (key, testedData, afterSubmit = true) => {
		if (isValidated === false && afterSubmit) {
			return true
		}
		switch (key) {
			case "phone_number":
				if (/^[0-9\s+()]+$/.test(testedData) === false) {
					return false
				}
				return true
			case "postal_code":
				if (/^(?!.*;)[1-9][0-9]{4}$/.test(testedData) === false) {
					return false
				}
				return true
			case "all_field":
			case "name":
			case "address":
			case "email":
			case "address_name":
				if (/^(?:[^;]+)$/.test(testedData) === false) {
					return false
				}
				return true
			case "country":
			case "province":
			case "city":
			case "district":
				if (testedData === "") {
					return false
				}
				return true
			case "number":
				if(/^[0-9]*$/.test(testedData) === false){
					return false
				}
				return true
			default:
				return true
		}
	}

	const scrollError = (checkValidate) => {
		let classInvalid = document.querySelector(".is-invalid")
		if (classInvalid && checkValidate) {
			classInvalid.scrollIntoView()
		}
	}

	useEffect(() => {
		scrollError(isValidated)
	}, [isValidated])

	const handleSubmit = (event) => {
		const form = event.currentTarget
		setIsValidated(true)
		event.preventDefault()
		let json_data = Object.assign({}, form_data.value)
		Object.keys(form_data.value).map((key) => {
			return (json_data[key] = form_data.value[key])
		})
		scrollError(isValidated)
		const isAllFieldsValid =
			checkRegex("name", json_data.name, false) &&
			checkRegex("address", json_data.address, false) &&
			checkRegex("email", json_data.email, false) &&
			checkRegex("address_name", json_data.address_name, false) &&
			checkRegex("phone_number", json_data.phone_number, false) &&
			checkRegex("postal_code", json_data.postal_code, false)

		if (form.checkValidity() && isAllFieldsValid) {
			if (form_id) {
				let event_data = {}
				event_data["eventUrl"] = param.value?.eventUrl
				event_data["apiUrl"] = param.value?.apiUrl
				edit_address(form_id, json_data, event_data)
			} else {
				json_data["event"] = {}
				json_data["event"]["eventUrl"] = param.value?.eventUrl
				json_data["event"]["apiUrl"] = param.value?.apiUrl
				create_address(json_data)
			}
		}
	}

	const renderInvalid = (data) =>{
		if(data.type === 'number'){
			return !checkRegex(`number`, form_data.value[data?.name]);
		}else{
			return !checkRegex(data?.name, form_data.value[data?.name]);
		}

	}

	return (
		<Form id="form" noValidate validated={isValidated} onSubmit={handleSubmit}>
			<div className="form-wrapper p-lg-5 p-3 pb-lg-0 pb-0">
				<div className="row">
					{list_field.length > 0 &&
						list_field.map((data, x) => (
							<ListField
								key={x}
								type={data?.type}
								name={data?.name}
								sort={data?.sort}
								required={data?.required}
								feedback={true}
								maxLength={data?.maxLength}
								readOnly={data?.readOnly}
								invalid={renderInvalid(data)}
							/>
						))}
				</div>
				<div className="row">
					<div className="col-12">
						<Form.Group className="mb-5" controlId="agree">
							<Form.Check
								required
								feedback="You must agree before submitting."
								feedbackType="invalid"
								onChange={(e) => {
									const { checked } = e.target
									changeFormData("agree", checked)
								}}
								label={t("agree_tnc")}
							/>
						</Form.Group>
					</div>
				</div>
				<Button className="p-5 py-2 m-auto d-flex" variant="danger" type="submit">
					{t("send")}
				</Button>
			</div>
		</Form>
	)
}

export default RegistrationForm
